/**
 * What a subscription means right now, as the API reports it. `scheduled` is an
 * active plan whose start day has not come yet, and `frozen` one inside a
 * freeze: neither lets anyone in.
 */
export type SubscriptionStatus =
  | 'active'
  | 'scheduled'
  | 'frozen'
  | 'expired'
  | 'depleted'
  | 'cancelled'

export const SUBSCRIPTION_STATUS_STYLES: Record<SubscriptionStatus, string> = {
  active: 'bg-success/10 text-success',
  scheduled: 'bg-primary/10 text-primary',
  // Fixed ice blue, not `secondary`: that is the gym's own brand colour, and a
  // pale one made the label unreadable.
  frozen: 'bg-sky-500/10 text-sky-700 dark:text-sky-300',
  expired: 'bg-danger/10 text-danger',
  depleted: 'bg-warning/10 text-warning',
  cancelled: 'bg-default/10 text-foreground/40',
}

/** Holds a plan, now, later or frozen: what can be edited rather than sold anew. */
export function holdsPlan(status: SubscriptionStatus | null | undefined): boolean {
  return status === 'active' || status === 'scheduled' || status === 'frozen'
}
